import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";
import lodash from "lodash";

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses?.includes(initialModel.refStatus?.key) || disabledRequestTypes?.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) {
                return false;
            }
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" }) || record.isOfficerCreate) {
                if ([null, "draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = lodash.cloneDeep(store.state.resource.auth.info?.user);
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refSampling.refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
                    "refSampling",
                    "refSamplingTemp.samplingDatetime",
                    "refSamplingTemp.refOperation",
                    "refSamplingTemp.manufactureDate",
                    "refSamplingTemp.manufactureExpireDate",
                    "refSamplingTemp.manufacturer",
                    "refSamplingTemp.importer",
                    "refSamplingTemp.distributor",
                    "refSamplingTemp.size",
                    "refSamplingTemp.refSizeUnit",
                    "refSamplingTemp.qty",
                    "refSamplingTemp.refQtyUnit",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refSamplingTemp.distributor",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (modelRef.refSamplingTemp?.distributors?.length) {
                    return false
                }
                return true;
            },
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SamplingDistributorList`, "g").test(componentKey);
            },
            visibleField: ({ modelRef }) => {
                if (modelRef.refSamplingTemp?.distributors?.length) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["remark", "lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forApproveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
    ];
};
